<template>
  <div class="catalog-card">
    <router-link
      class="catalog-card__link-area"
      :to="{ name: 'CatalogListing', query: { currentCategoryId: categoryId.toString() } }"
    >
      <div class="catalog-card__content-wrapper">
        <div class="catalog-card__image-wrapper">
          <img
            v-if="imageLoadFailed === false"
            :src="GetCategoryImage(categoryImageId)"
            class="catalog-card__image"
            @error="OnImageLoadFailed"
          />
          <img v-if="imageLoadFailed === true" :src="getImage('imageNotFound')" class="catalog-card__image" />
        </div>
        <div class="catalog-card__title-wrapper">
          {{ title }}
          <fa-icon v-if="!isLeaf" icon="caret-down" />
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import { CatalogService } from "@/services/CatalogService";
import { themeHelper } from "@/components/mixins/themeHelper";
import { ErrorLogService } from "@/services/ErrorLogService";

export default {
  mixins: [themeHelper],
  props: {
    title: {
      type: String,
      default: "...",
    },
    categoryImageId: {
      type: String,
      default: "",
    },
    categoryId: {
      type: Number,
      default: 0,
    },
    isLeaf: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      imageLoadFailed: false,
    };
  },
  methods: {
    GetCategoryImage(imageId) {
      if (imageId !== null && imageId !== "0") {
        return CatalogService.GetMediaUrl(imageId);
      }
      return this.getImage("noCategoryImageFound");
    },
    OnImageLoadFailed() {
      this.imageLoadFailed = true;
    },
  },
};
</script>

<style lang="scss">
.catalog-card {
  display: block;
  height: 100%;
  line-height: 1;
  &:hover,
  &:focus {
    box-shadow: 0 0 16px 0 rgba(25, 118, 210, 0.18);
    background: #f5f7fa;
    text-decoration: none;
  }
  border-radius: 5px;
}

.catalog-card__link-area {
  padding: 8px;
  display: block;
  height: 100%;
  width: 100%;
  color: black;
  &:hover {
    text-decoration: none !important;
  }
  align-content: end;
}

.catalog-card__content-wrapper {
  color: black;
}

.catalog-card__image-wrapper {
  text-align: center;
  color: black;
  padding-top: 6px;
}

.catalog-card__image {
  border-radius: 4px;
  max-width: 150px;
}

.catalog-card__title-wrapper {
  text-align: center;
  padding: 6px;
  word-break: break-word;
}

.catalog-card__title-wrapper .fa-caret-down {
  color: #b3b3b3;
}
</style>